import CategoryLink from './navigation-category-link'

export default ({ categories, currentParent, currentCategory }) => {
  return <div>
    {categories.map(parentCategory => {
      const isCurrentParent = currentParent === parentCategory.id
      const isCurrent = currentCategory === parentCategory.id

      return <div class='knowledge-base-navigation-parent-wrapper'>
        <CategoryLink url={parentCategory.url} isCurrent={isCurrent}>
          {parentCategory.title}
        </CategoryLink>
        {isCurrentParent
          ? <div class='knowledge-base-navigation-categories-block'>
            {parentCategory.subforums.map(category => {
              const isCurrent = currentCategory === category.id
              return <CategoryLink url={category.url} isCurrent={isCurrent}>
                {category.title}
              </CategoryLink>
            })}
          </div>
          : null}
      </div>
    })}
  </div>
}
